module.exports = "<div>\n  <div style=\"display: block\">\n    <canvas #chartPvTargetValue></canvas>\n  </div>\n</div>"